module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .control-multi-select .editor {\n        border     : 1px solid #ddd;\n        padding    : 5px;\n    }\n\n    .control-multi-select .editor .options {\n        max-height : 300px;\n        overflow   : auto;\n    }\n</style>\n<div class=\"control-multi-select\">\n    <div class=\"display\">\n        <span class=\"values\"></span>\n        <span class=\"edit icon-mode_edit gl-pointer\"></span>\n    </div>\n    <div class=\"hidden editor\">\n        <div class=\"options\">\n            ")
    ;  _.forEach(source, function(row) { 
    ; __append("\n            <label>\n                <input type=\"checkbox\" value=\"")
    ; __append(escapeFn( row[value] ))
    ; __append("\"> ")
    ; __append(escapeFn( row[title] ))
    ; __append("\n            </label><br>\n            ")
    ;  }) 
    ; __append("\n        </div>\n        <div style=\"text-align: center;\">\n            <span class=\"close gl-action\">Готово</span>\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}